import React from 'react';

/**
 * Section tab bar for the help drawer — one tab per section (icon + label).
 */
export default function HelpNav({ sections, activeSectionId, onSelect }) {
  return (
    <div className="help-nav" role="tablist" aria-label="Help sections">
      {sections.map((section) => (
        <button
          key={section.id}
          type="button"
          role="tab"
          aria-selected={section.id === activeSectionId}
          className={`help-tab${section.id === activeSectionId ? ' active' : ''}`}
          onClick={() => onSelect(section.id)}
        >
          <i className={`${section.icon} me-2`} aria-hidden="true" />
          {section.title}
        </button>
      ))}
    </div>
  );
}
